import { usePreventRemove } from '@react-navigation/native';
import { useNavigation } from 'expo-router';
import { useModal } from '../contexts/ModalContext';
import { useTranslation } from '../contexts/TranslationContext';

export function useUnsavedChangesGuard(hasUnsavedChanges: boolean) {
  const navigation = useNavigation();
  const { confirm } = useModal();
  const { t } = useTranslation();

  usePreventRemove(hasUnsavedChanges, async ({ data }) => {
    const discard = await confirm({
      title: t('common.unsavedChanges.title'),
      message: t('common.unsavedChanges.message'),
      confirmLabel: t('common.unsavedChanges.discard'),
      cancelLabel: t('common.unsavedChanges.keepEditing'),
      variant: 'destructive',
    });
    if (discard) navigation.dispatch(data.action);
  });
}
